import React from 'react';
import block from 'propmods';
import * as keyset from 'i18n/Promotion';
import i18n from '@yandex-int/i18n';
import { Field } from '../Form/Form';
import { Skill } from '../../model/skill';
import { Badge, badges } from './badges';
import CopyField from '../CopyField/CopyField';
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';
import Link from '../Link/Link';
import { PageSegment } from '../PageSegment/PageSegment';
import { Select } from '../Select/Select';

import './PromotionPage.scss';

const t = i18n(keyset);

const { storeUrl, deepLinkUrl, displayDeepLinks } = __appConfig.app;

interface PromotionPageProps {
    skill: Skill;
}

interface PromotionPageState {
    theme: Badge;
    tooltipVisible: boolean;
}

const b = block('PromotionPage');

const stubText = t('error-no-available');

const THEME_OPTIONS = [
    { value: 'black', text: t('color-black') },
    { value: 'white', text: t('color-white') },
    { value: 'black-monochrome', text: t('color-black-transparent') },
    { value: 'white-monochrome', text: t('color-white-transparent') },
];

class PromotionPage extends React.Component<PromotionPageProps, PromotionPageState> {
    public state: PromotionPageState = {
        theme: Badge.Black,
        tooltipVisible: false,
    };

    public render() {
        const { Badge: BadgeComp, term } = badges[this.state.theme];
        const { skill } = this.props;

        const showDeepLinks = displayDeepLinks || Boolean(sessionStorage.getItem('__display-deep-links'));
        const skillVisibleInStore = skill.onAir && !skill.hideInStore;

        return (
            <ErrorBoundary withHomepageLink>
                <section {...b()}>
                    <PageSegment title={t('header-badge-for-site')} available={skillVisibleInStore} stubText={stubText}>
                        <Field label={t('label-theme')} name="theme">
                            <Select
                                namespace="theme"
                                onChange={(value) => {
                                    this.onChange(value as Badge);
                                }}
                                type="radio"
                                value={this.state.theme}
                                options={THEME_OPTIONS}
                            />
                        </Field>
                        <Field label={t('label-badge')}>
                            <div {...b('stage')}>
                                <BadgeComp />
                            </div>
                        </Field>
                        <CopyField
                            text={generateLink({ slug: skill.slug, term })}
                            buttonLabel={t('button-text-copy')}
                            label={t('label-text-copy')}
                        />
                    </PageSegment>

                    {showDeepLinks && (
                        <PageSegment
                            title={t('header-direct-link')}
                            available={skillVisibleInStore}
                            stubText={stubText}
                            offsetTop
                        >
                            <CopyField
                                text={generateDeepLink(skill.id)}
                                buttonLabel={t('button-text-copy')}
                                label={t('label-quick-launch')}
                            />
                        </PageSegment>
                    )}
                </section>
            </ErrorBoundary>
        );
    }

    private onChange = (theme: Badge) => this.setState({ theme });
}

interface LinkOptions {
    slug: string;
    term: number;
}

// Ссылка в одну строку, так как в textarea вставляется текст с учетом всех отступов из кода
function generateLink({ slug, term }: LinkOptions) {
    return `<a href="${storeUrl}/skills/${slug}?utm_source=site&utm_medium=badge&utm_campaign=v1&utm_term=d${term}" target="_blank"><img alt="Алиса это умеет" src="https://dialogs.s3.yandex.net/badges/v1-term${term}.svg"/></a>`;
}

function generateDeepLink(id: string) {
    return `${deepLinkUrl.replace(/\/$/, '')}/${id}`;
}

export default PromotionPage;
